module.exports = __webpack_public_path__ + "img/tz.1eb4df42.jpg";